import React from 'react';
// import { FormGroup, Input, FormFeedback, Label} from 'reactstrap'
import {connect} from 'react-redux'; 
import StringInput from "../StringInput"
import * as actions from "store/actions/colors"
import validation from '../../validation';
import * as yup from 'yup';

class ColorCodeField extends React.Component {

    constructor(props){
        super(props)
        this.state = {
            name: "code",
            invalid: false
        }
        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount(){
   
    }

    handleChange(event){
        let value = event.target.value
        yup.reach(validation, this.state.name).validate(value, {abortEarly: false}).then( (resp) => {
            this.setState({invalid: false})
            this.props.actions.setError(this.state.name, "")
        }).catch( (err) => {
            for(let error of err.inner){
                this.setState({invalid: true})
                this.props.actions.setError(this.state.name, error.message)
            }
        })
        this.props.actions.changeCode(this.state.name, value)

    }

    
    render(){
        return(
           <StringInput 
                label="Cor"
                value={this.props.code}
                name={this.state.name}
                placeholder="Código da Cor"
                onChange={ this.handleChange}
                invalid={this.state.invalid}
                error={this.props.error}
                >
            </StringInput>
        );
    }
}
const mapStateToProps = (state) => {
    return {
         code: state.colors.color.code,
         error: state.colors.errors.code
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        actions:{
            setError: (name, value) => {
                return dispatch({
                    type: actions.SET_ERROR,
                    payload: {
                        name: name,
                        value: value
                    }
                })
            },
            changeCode: (name, value) => {
                return dispatch({
                    type: actions.CHANGE_ATTR,
                    payload: {
                        name: name,
                        value: value
                    }
                })
            }
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ColorCodeField);